export default __webpack_public_path__ + "static/media/status-normal.3e402bae.svg";